// extracted by mini-css-extract-plugin
export default {"status":"TransactionStatus_status__RZDN9","status_text":"TransactionStatus_status_text__00zMI"};